export interface CacheInfoState {
    version: string;
    rehydrated: boolean;
}

export const initialCacheInfoState: CacheInfoState = {
    version: '1.0.0',
    rehydrated: false,
};
